// extracted by mini-css-extract-plugin
module.exports = {"uloadNotesLink":"Uload_uloadNotesLink__jdDAL","logOption":"Uload_logOption__1PJF0","uloadNotesIcon":"Uload_uloadNotesIcon__2E5I1","loadingScreen":"Uload_loadingScreen__2mp5-"};